
export type EnrollmentCreateWaitlistedResult = typeof EnrollmentCreateWaitlistedResult[keyof typeof EnrollmentCreateWaitlistedResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateWaitlistedResult = {
  waitlisted: 'waitlisted',
} as const;
